export default "__VITE_PUBLIC_ASSET__1a445383__"